import { BlocksIconExternalLinkBox } from 'blocks-nextjs/blocks-web-components/components/icon/icons/external-link-box';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconExternalLinkBox = createComponent({
  react: React,
  tagName: 'cat-icon-external-link-box',
  elementClass: BlocksIconExternalLinkBox
});
